import React, { useState, useEffect  } from 'react'
import { Link } from "react-router-dom";
import ImageSlider from '../components/ImageSlider';
import axios from "axios";
import PropTypes from "prop-types";
import { motion,AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight,ChevronDown  } from "lucide-react"; 
import { GraduationCap, Users, BookOpen, Building2 } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FaWhatsapp, FaGraduationCap, FaUsers, FaNewspaper, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { MdOutlineAppRegistration } from "react-icons/md";
import {
  FaArrowRight,
  FaDownload,
  FaFileAlt,
  FaClipboardList,
  FaIdCard,
  FaAward,
  FaCheckCircle,
  FaRocket,
  FaBookOpen
} from "react-icons/fa";
import {
  ArrowRight,
  CheckCircle2,
  Sparkles,
  Globe2,
  Award,
  Lightbulb,
  Bell,
  CalendarDays,  
  ExternalLink,
  Quote,  
  Newspaper,
} from "lucide-react";


function HomePage(){
	const [notices, setNotices] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [news, setNews] = useState([]);
	const [videos, setvideos] = useState([]);
	const [selectedVideo, setSelectedVideo] = useState(null);
	const [autoPlay, setAutoPlay] = useState(false);
	const [events, setEvents] = useState([]);
	
	const items = [
	  {
		icon: <GraduationCap className="w-10 h-10" />,
		title: "Scholarships & Student Services",
		desc: "UCTC offers scholarships to graduate and undergraduate students through a semester-wise scholarship selection process.",
		link: "#",
	  },
	  {
		icon: <Users className="w-10 h-10" />,
		title: "International Students",
		desc: "University of Creative Technology Chittagong was established by UCTC Trust in 2015 for the public benefit and is recognized.",
		link: "#",
	  },
	  {
		icon: <BookOpen className="w-10 h-10" />,
		title: "Degrees and Certificates",
		desc: "UCTC offers 8 programs under 3 distinct Schools namely School of Arts and Social Sciences, School of Business, and School of Science and Engineering.",
		link: "#",
	  },
	  {
		icon: <Building2 className="w-10 h-10" />,
		title: "University Life",
		desc: "The Campus Life Division provides a wide range of administrative and support services to the University community.",
		link: "#",
	  },
	];
	const handlePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:'0',
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },				
			});
			const response = await api.post("/recent-notice", payload);
			
			
			// Loop data (array)
			setNotices(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	const newsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:'0',
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },				
			});
			const response = await api.post("/recent-news", payload);
			
			
			// Loop data (array)
			setNews(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	const videoPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
				department_id:'0',
			});
			const response = await api.post("/recent-videos", payload);
			
			const data = response.data;
			// Loop data (array)
			setvideos(response.data || []);
			
			if (data.length > 0) {
			  setSelectedVideo(data[0]);
			  setAutoPlay(false);
			}
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	const eventsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
				department_id:'0',
			});
			const response = await api.post("/recent-events", payload);
			
			
			// Loop data (array)
			setEvents(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		handlePost();		
		newsPost();
		videoPost();
		eventsPost();
	}, []);
	
	const bachelorPrograms = [
		{ name: "Bachelor of Business Administration (BBA)", link: "/programs/bba" },
		{ name: "B.Sc in Civil Engineering", link: "/programs/civil" },
		{ name: "B.Sc in Mechanical Engineering", link: "/programs/mechanical" },
		{ name: "B.Sc in Computer Science & Engineering", link: "/programs/cse" },
		{ name: "B.A (Hons) in English Language & Literature", link: "/programs/english" },
		{ name: "B.Sc in Electrical & Electronic Engineering", link: "/programs/eee" },
		{ name: "B.A (Hons) in Islamic Studies", link: "/programs/bis" },
		{ name: "Bachelor of Hospitality and Tourism Management", link: "/programs/htm" },
		{ name: "B.Sc in Textile Engineering", link: "/programs/bte" },
	];

	const masterPrograms = [
		{ name: "Master of Business Administration", link: "/programs/mba" },
		{ name: "Master of Public Health", link: "/programs/mph" },
		{ name: "Master of Islamic Studies", link: "/programs/mis" },
	];
	
	return (
		<>
			<ImageSlider />	
			
			<section className="relative isolate overflow-hidden bg-gradient-to-br from-[#063B59] via-[#087BA5] to-[#42BCE8] py-20 md:py-24">

			  {/* Animated Background */}
			  <div className="absolute inset-0 overflow-hidden pointer-events-none">
				<motion.div
				  animate={{ x: [0, 40, 0], y: [0, -30, 0] }}
				  transition={{ duration: 12, repeat: Infinity }}
				  className="absolute -top-32 -left-20 w-96 h-96 rounded-full bg-cyan-300/20 blur-3xl"
				/>
				<motion.div
				  animate={{ x: [0, -40, 0], y: [0, 30, 0] }}
				  transition={{ duration: 15, repeat: Infinity }}
				  className="absolute -bottom-32 -right-20 w-96 h-96 rounded-full bg-blue-300/20 blur-3xl"
				/>

				<div className="absolute inset-0 opacity-[0.08]"
				  style={{
					backgroundImage: "radial-gradient(#fff 1px, transparent 1px)",
					backgroundSize: "28px 28px"
				  }}
				/>
			  </div>

			  <div className="container mx-auto px-5 relative z-10">

				{/* Admission Heading */}
				<motion.div
				  initial={{ opacity: 0, y: 40 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  transition={{ duration: 0.8 }}
				  className="text-center max-w-4xl mx-auto"
				>
				  <motion.div
					animate={{ scale: [1, 1.05, 1] }}
					transition={{ duration: 2, repeat: Infinity }}
					className="inline-flex items-center gap-2 px-5 py-2 mb-6 rounded-full bg-yellow-400 text-[#063B59] text-sm font-bold shadow-lg"
				  >
					<span className="w-2 h-2 bg-red-600 rounded-full animate-pulse" />
					ADMISSION IS NOW OPEN
				  </motion.div>

				  <h2 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6">
					Shape Your Future
					<span className="block text-yellow-300 mt-2">
					  Start Your Journey Today!
					</span>
				  </h2>

				  <p className="text-white/85 text-base md:text-xl leading-relaxed max-w-3xl mx-auto mb-9">
					We don't just provide education. We empower students with knowledge,
					practical experience, innovation and leadership skills to build
					successful careers and make a difference in the world.
				  </p>

				  <div className="flex flex-wrap justify-center gap-4">

					<motion.a
					  href="/apply-online"
					  whileHover={{ scale: 1.07, y: -4 }}
					  whileTap={{ scale: 0.96 }}
					  className="group flex items-center gap-3 px-8 py-4 bg-yellow-400 text-[#063B59] font-extrabold rounded-full shadow-xl hover:bg-yellow-300 transition-all"
					>
					  <FaGraduationCap className="text-xl" />
					  Apply Online
					  <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
					</motion.a>

					<motion.a
					  href="#our-programs"
					  whileHover={{ scale: 1.05, y: -4 }}
					  className="flex items-center gap-3 px-8 py-4 bg-white/15 backdrop-blur-md border border-white/40 text-white font-bold rounded-full hover:bg-white/25 transition-all"
					>
					  Explore Programs
					  <FaArrowRight />
					</motion.a>

				  </div>
				</motion.div>

				{/* Admission Resources */}
				<motion.div
				  initial={{ opacity: 0, y: 40 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  transition={{ duration: 0.8, delay: 0.2 }}
				  className="max-w-6xl mx-auto mt-16"
				>
				  <div className="text-center mb-6">
					<span className="text-white/70 uppercase tracking-[0.25em] text-xs font-bold">
					  Admission Resources
					</span>
					<h3 className="text-white text-xl md:text-2xl font-bold mt-2">
					  Everything You Need to Get Started
					</h3>
				  </div>

				  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">

					{[
					  { name: "Advertisement", link: "/admission-advertisement", icon: FaFileAlt },
					  { name: "Requirements", link: "/admission-requirement", icon: FaClipboardList },
					  { name: "Instructions", link: "/admission-instruction", icon: FaBookOpen },
					  { name: "Admission Form", link: "/admission-form", icon: FaDownload },
					  { name: "Admit Card", link: "/admit-card", icon: FaIdCard },
					  { name: "Offer Letter", link: "/offer-letter", icon: FaAward }
					].map((item, index) => {
					  const Icon = item.icon;

					  return (
						<motion.a
						  key={index}
						  href={item.link}
						  initial={{ opacity: 0, y: 20 }}
						  whileInView={{ opacity: 1, y: 0 }}
						  viewport={{ once: true }}
						  transition={{ delay: index * 0.08 }}
						  whileHover={{ y: -8, scale: 1.03 }}
						  className="group flex flex-col items-center justify-center text-center gap-3 p-5 min-h-[145px] rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 hover:bg-white hover:border-white shadow-lg transition-all duration-300"
						>
						  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/15 text-yellow-300 text-2xl group-hover:bg-[#087BA5] group-hover:text-white transition-all">
							<Icon />
						  </div>

						  <span className="text-white group-hover:text-[#063B59] text-sm font-bold transition-colors">
							{item.name}
						  </span>

						  <FaArrowRight className="text-xs text-white/50 group-hover:text-[#087BA5] group-hover:translate-x-1 transition-all" />
						</motion.a>
					  );
					})}

				  </div>
				</motion.div>

				{/* Contact Information */}
				<div className="max-w-6xl mx-auto mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">

				  {[
					{
					  icon: FaMapMarkerAlt,
					  title: "Visit Our Campus",
					  value: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212"
					},
					{
					  icon: FaPhoneAlt,
					  title: "Call Admission Office",
					  value: "+8801707508080, +8801707508081"
					},
					{
					  icon: FaEnvelope,
					  title: "Email Us",
					  value: "info@uctc.edu.bd"
					}
				  ].map((item, index) => {
					const Icon = item.icon;

					return (
					  <motion.div
						key={index}
						whileHover={{ y: -5 }}
						className="flex items-center gap-4 p-5 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20"
					  >
						<div className="shrink-0 w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center text-[#063B59] text-xl">
						  <Icon />
						</div>

						<div className="min-w-0">
						  <h4 className="text-white font-bold mb-1">{item.title}</h4>
						  <p className="text-white/75 text-sm leading-relaxed break-words">
							{item.value}
						  </p>
						</div>
					  </motion.div>
					);
				  })}

				</div>

			  </div>
			</section>

						
			<section
			  id="our-programs"
			  className="relative overflow-hidden py-20 md:py-24 bg-gradient-to-b from-[#F0FBFF] via-white to-[#E8F8FE]"
			>

			  {/* Background Decorations */}
			  <div className="absolute top-20 -left-32 w-80 h-80 bg-cyan-300/20 rounded-full blur-3xl pointer-events-none" />
			  <div className="absolute bottom-20 -right-32 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl pointer-events-none" />

			  <div className="container mx-auto px-5 relative z-10">

				{/* Section Heading */}
				<motion.div
				  initial={{ opacity: 0, y: 40 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  transition={{ duration: 0.7 }}
				  className="text-center max-w-3xl mx-auto mb-16"
				>
				  <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#DDF5FF] text-[#087BA5] font-bold text-sm mb-5">
					<FaGraduationCap />
					ACADEMIC EXCELLENCE
				  </span>

				  <h2 className="text-4xl md:text-5xl font-extrabold text-[#063B59] mb-5">
					Explore Our
					<span className="text-[#159BCB]"> Academic Programs</span>
				  </h2>

				  <p className="text-gray-600 text-base md:text-lg leading-relaxed">
					Discover your passion, develop your potential and prepare for
					tomorrow's opportunities with our industry-oriented academic programs.
				  </p>

				  <div className="flex items-center justify-center gap-2 mt-7">
					<span className="w-12 h-1 bg-[#087BA5] rounded-full" />
					<span className="w-3 h-3 rounded-full bg-yellow-400" />
					<span className="w-12 h-1 bg-[#087BA5] rounded-full" />
				  </div>
				</motion.div>

				{/* Program Category Component */}
				{[
				  {
					title: "Bachelor Programs",
					subtitle: "Undergraduate Degree Programs",
					description: "Build a strong academic foundation and develop professional skills for your future career.",
					icon: FaGraduationCap,
					programs: bachelorPrograms,
					color: "#087BA5",
					light: "#E2F6FD"
				  },
				  {
					title: "Master Programs",
					subtitle: "Postgraduate Degree Programs",
					description: "Advance your expertise, expand your knowledge and take your career to the next level.",
					icon: FaAward,
					programs: masterPrograms,
					color: "#7352B8",
					light: "#F0EAFF"
				  }
				].map((category, categoryIndex) => {
				  const Icon = category.icon;

				  return (
					<div key={category.title} className="mb-16 last:mb-0">

					  {/* Category Header */}
					  <motion.div
						initial={{ opacity: 0, x: -30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.6 }}
						className="flex flex-col md:flex-row md:items-center justify-between gap-5 mb-8"
					  >
						<div className="flex items-center gap-4">
						  <div
							className="w-16 h-16 shrink-0 flex items-center justify-center rounded-2xl shadow-lg text-white text-3xl"
							style={{ background: category.color }}
						  >
							<Icon />
						  </div>

						  <div>
							<span
							  className="text-xs font-bold uppercase tracking-widest"
							  style={{ color: category.color }}
							>
							  {category.subtitle}
							</span>

							<h3 className="text-2xl md:text-3xl font-extrabold text-[#063B59]">
							  {category.title}
							</h3>
						  </div>
						</div>

						<p className="text-gray-500 text-sm md:max-w-md md:text-right">
						  {category.description}
						</p>
					  </motion.div>

					  {/* Program Cards */}
					  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

						{category.programs.map((program, index) => (
						  <motion.a
							key={index}
							href={program.link}
							initial={{ opacity: 0, y: 35 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true, amount: 0.2 }}
							transition={{
							  duration: 0.5,
							  delay: index * 0.08
							}}
							whileHover={{ y: -9 }}
							className="group relative overflow-hidden flex items-center gap-4 bg-white rounded-2xl p-6 border border-gray-100 shadow-[0_5px_25px_rgba(0,50,80,0.05)] hover:shadow-[0_15px_40px_rgba(0,80,130,0.13)] transition-all duration-300"
						  >

							{/* Hover Background */}
							<div
							  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
							  style={{
								background: `linear-gradient(120deg, ${category.light}, white)`
							  }}
							/>

							{/* Left Accent */}
							<div
							  className="absolute top-0 left-0 w-1 h-0 group-hover:h-full transition-all duration-500 rounded-full"
							  style={{ background: category.color }}
							/>

							{/* Program Number / Icon */}
							<div
							  className="relative z-10 shrink-0 w-14 h-14 rounded-xl flex items-center justify-center text-xl font-extrabold transition-all duration-300 group-hover:scale-110"
							  style={{
								background: category.light,
								color: category.color
							  }}
							>
							  <FaBookOpen />
							</div>

							{/* Program Name */}
							<div className="relative z-10 flex-1 min-w-0">
							  <span
								className="block text-xs font-bold mb-1"
								style={{ color: category.color }}
							  >
								PROGRAM {String(index + 1).padStart(2, "0")}
							  </span>

							  <h4 className="text-gray-800 font-bold text-base md:text-lg leading-snug group-hover:text-[#063B59] transition-colors">
								{program.name}
							  </h4>

							  <span className="inline-flex items-center gap-2 text-xs font-semibold mt-3 opacity-70 group-hover:opacity-100 transition-opacity"
								style={{ color: category.color }}
							  >
								Explore Program
								<FaArrowRight className="group-hover:translate-x-2 transition-transform" />
							  </span>
							</div>

						  </motion.a>
						))}

					  </div>
					</div>
				  );
				})}

				{/* Bottom CTA */}
				<motion.div
				  initial={{ opacity: 0, scale: 0.95 }}
				  whileInView={{ opacity: 1, scale: 1 }}
				  viewport={{ once: true }}
				  className="mt-16 relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#063B59] via-[#087BA5] to-[#159BCB] p-8 md:p-12 text-center shadow-xl"
				>
				  <div className="absolute -top-20 -right-20 w-64 h-64 bg-white/10 rounded-full blur-2xl" />
				  <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-cyan-200/10 rounded-full blur-2xl" />

				  <div className="relative z-10">
					<FaRocket className="text-yellow-300 text-4xl mx-auto mb-5" />

					<h3 className="text-white text-2xl md:text-3xl font-extrabold mb-4">
					  Your Future Starts Here!
					</h3>

					<p className="text-white/80 max-w-2xl mx-auto mb-8">
					  Take the first step towards your dream career.
					  Join UCTC and become part of a community of future leaders.
					</p>

					<motion.a
					  href="/apply-online"
					  whileHover={{ scale: 1.06 }}
					  whileTap={{ scale: 0.96 }}
					  className="inline-flex items-center gap-3 px-9 py-4 rounded-full bg-yellow-400 text-[#063B59] font-extrabold shadow-lg hover:bg-yellow-300 transition-all"
					>
					  Apply for Admission
					  <FaArrowRight />
					</motion.a>
				  </div>
				</motion.div>

			  </div>
			</section>

			
			{/* ABOUT UCTC SECTION */}
			<section className="relative overflow-hidden bg-gradient-to-br from-[#F0FCFF] via-white to-[#E1F6FD] py-20 md:py-28">

			  {/* Background Decorations */}
			  <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-200/30 rounded-full blur-3xl pointer-events-none" />
			  <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-200/30 rounded-full blur-3xl pointer-events-none" />

			  <div className="container mx-auto px-5 relative z-10">

				<div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">

				  {/* LEFT: Campus Image */}
				  <motion.div
					initial={{ opacity: 0, x: -60 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.2 }}
					transition={{ duration: 0.9 }}
					className="relative group"
				  >

					{/* Decorative Border */}
					<div className="absolute -top-5 -left-5 w-full h-full border-2 border-[#159BCB]/40 rounded-[2rem] transition-transform duration-700 group-hover:-translate-x-2 group-hover:-translate-y-2" />

					{/* Image */}
					<div className="relative overflow-hidden rounded-[2rem] shadow-2xl">
					  <img
						src="/img/about-uctc.jpg"
						alt="University of Creative Technology Chittagong Campus"
						className="w-full h-[380px] md:h-[530px] object-cover transition-transform duration-1000 group-hover:scale-110"
					  />

					  <div className="absolute inset-0 bg-gradient-to-t from-[#063B59]/80 via-transparent to-transparent" />

					  <div className="absolute bottom-0 left-0 right-0 p-7 md:p-9">
						<span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-400 text-[#063B59] text-xs font-extrabold uppercase tracking-wider mb-4">
						  <Sparkles size={14} />
						  Excellence in Education
						</span>

						<h3 className="text-2xl md:text-3xl text-white font-extrabold">
						  Building Knowledge.
						  <span className="block text-yellow-300">
							Creating Futures.
						  </span>
						</h3>
					  </div>
					</div>

					{/* Floating Experience Card */}
					<motion.div
					  animate={{ y: [0, -10, 0] }}
					  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
					  className="absolute -bottom-8 -right-3 md:-right-8 bg-white rounded-2xl shadow-2xl p-5 md:p-6 border border-cyan-100"
					>
					  <div className="flex items-center gap-4">
						<div className="w-14 h-14 rounded-xl bg-[#E3F7FD] flex items-center justify-center">
						  <Award className="w-8 h-8 text-[#087BA5]" />
						</div>
						<div>
						  <h4 className="text-2xl font-extrabold text-[#063B59]">
							2015
						  </h4>
						  <p className="text-sm text-gray-500 font-medium">
							Established
						  </p>
						</div>
					  </div>
					</motion.div>

					{/* Floating Decorative Circle */}
					<div className="absolute -top-8 -right-5 w-20 h-20 rounded-full border-[10px] border-yellow-400/70 -z-10" />

				  </motion.div>

				  {/* RIGHT: About Content */}
				  <motion.div
					initial={{ opacity: 0, x: 60 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.2 }}
					transition={{ duration: 0.9 }}
					className="pt-4 lg:pt-0"
				  >

					<span className="inline-flex items-center gap-2 text-[#087BA5] bg-[#DDF5FD] rounded-full px-5 py-2 text-sm font-bold mb-5">
					  <Globe2 size={16} />
					  DISCOVER UCTC
					</span>

					<h2 className="text-4xl md:text-5xl font-extrabold text-[#063B59] leading-tight mb-7">
					  About
					  <span className="text-[#159BCB]"> UCTC</span>
					  <span className="block w-20 h-1.5 bg-yellow-400 rounded-full mt-5" />
					</h2>

					<p className="text-gray-600 text-base md:text-lg leading-8 mb-5">
					  The <strong className="text-[#063B59]">University of Creative Technology Chittagong</strong> thrives as a dynamic hub of learning dedicated to serving both the nation and humanity. Our educational mission is to equip students for purposeful lives and to tackle the future's challenges. With the goal of attracting the most talented students nationwide, we are committed to delivering an educational journey that enhances intellect, hones skills, broadens horizons and cultivates leadership qualities. Throughout this endeavor, we uphold the utmost standards of excellence.
					</p>

					<p className="text-gray-600 text-base md:text-lg leading-8 mb-7">
					  Established in 2015, the University of Creative Technology Chittagong was founded with a clear mission: to facilitate increased accessibility to superior education for students hailing from low-income households and to deliver educational excellence that aligns with international standards. Currently, the university boasts an enrollment of around <strong className="text-[#087BA5]">3000 students</strong>, with a significant enrollment density observed in the Mechanical Engineering department, followed closely by Civil and Computer Science Engineering.
					</p>

					{/* Highlights */}
					<div className="grid grid-cols-2 gap-4 mb-9">

					  <div className="flex items-center gap-3 p-4 rounded-xl bg-white shadow-sm border border-gray-100">
						<CheckCircle2 className="text-[#159BCB] w-6 h-6 shrink-0" />
						<span className="text-sm font-bold text-[#063B59]">
						  Quality Education
						</span>
					  </div>

					  <div className="flex items-center gap-3 p-4 rounded-xl bg-white shadow-sm border border-gray-100">
						<CheckCircle2 className="text-[#159BCB] w-6 h-6 shrink-0" />
						<span className="text-sm font-bold text-[#063B59]">
						  Career Development
						</span>
					  </div>

					  <div className="flex items-center gap-3 p-4 rounded-xl bg-white shadow-sm border border-gray-100">
						<CheckCircle2 className="text-[#159BCB] w-6 h-6 shrink-0" />
						<span className="text-sm font-bold text-[#063B59]">
						  Research & Innovation
						</span>
					  </div>

					  <div className="flex items-center gap-3 p-4 rounded-xl bg-white shadow-sm border border-gray-100">
						<CheckCircle2 className="text-[#159BCB] w-6 h-6 shrink-0" />
						<span className="text-sm font-bold text-[#063B59]">
						  Student Success
						</span>
					  </div>

					</div>

					<motion.a
					  href="/about"
					  whileHover={{ scale: 1.06, x: 5 }}
					  whileTap={{ scale: 0.96 }}
					  className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-[#087BA5] to-[#159BCB] text-white rounded-full font-bold shadow-xl shadow-cyan-700/20 hover:shadow-cyan-700/40 transition-all"
					>
					  Discover More About UCTC
					  <ArrowRight size={19} />
					</motion.a>

				  </motion.div>

				</div>
			  </div>
			</section>

			
			{/* UNIVERSITY FEATURES SECTION */}
			<section className="relative overflow-hidden bg-[#F0FCFF] py-20 md:py-24">

			  {/* Background */}
			  <div className="absolute top-0 left-1/4 w-80 h-80 bg-cyan-200/20 rounded-full blur-3xl" />
			  <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-200/20 rounded-full blur-3xl" />

			  <div className="container mx-auto px-5 relative z-10">

				{/* Heading */}
				<motion.div
				  initial={{ opacity: 0, y: 35 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  transition={{ duration: 0.7 }}
				  className="text-center max-w-3xl mx-auto mb-14"
				>

				  <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border border-cyan-100 text-[#087BA5] text-sm font-bold shadow-sm mb-5">
					<Lightbulb size={16} />
					EXPLORE OUR UNIVERSITY
				  </span>

				  <h2 className="text-3xl md:text-5xl font-extrabold text-[#063B59] mb-5">
					Discover the
					<span className="text-[#159BCB]"> UCTC Experience</span>
				  </h2>

				  <p className="text-gray-600 text-base md:text-lg leading-relaxed">
					Explore the opportunities, services and experiences that make
					UCTC a place to learn, grow, innovate and succeed.
				  </p>

				  <div className="flex justify-center mt-6">
					<span className="w-16 h-1.5 rounded-full bg-[#087BA5]" />
					<span className="w-3 h-1.5 rounded-full bg-yellow-400 ml-2" />
					<span className="w-3 h-1.5 rounded-full bg-cyan-300 ml-2" />
				  </div>

				</motion.div>

				{/* Feature Cards */}
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

				  {items.map((item, index) => {

					const icons = [
					  GraduationCap,
					  Users,
					  BookOpen,
					  Building2
					];

					const Icon = icons[index % icons.length];

					const colors = [
					  {
						bg: "bg-cyan-50",
						icon: "text-[#087BA5]",
						accent: "#087BA5"
					  },
					  {
						bg: "bg-indigo-50",
						icon: "text-indigo-600",
						accent: "#4F46E5"
					  },
					  {
						bg: "bg-amber-50",
						icon: "text-amber-600",
						accent: "#D97706"
					  },
					  {
						bg: "bg-emerald-50",
						icon: "text-emerald-600",
						accent: "#059669"
					  }
					];

					const theme = colors[index % colors.length];

					return (
					  <motion.div
						key={index}
						initial={{ opacity: 0, y: 50 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true, amount: 0.2 }}
						transition={{
						  duration: 0.6,
						  delay: index * 0.12
						}}
						whileHover={{ y: -12 }}
						className="group relative flex flex-col bg-white rounded-3xl p-7 border border-gray-100 shadow-[0_8px_30px_rgba(0,50,80,0.05)] hover:shadow-[0_20px_50px_rgba(0,80,130,0.14)] transition-all duration-500 overflow-hidden"
					  >

						{/* Hover Top Border */}
						<div
						  className="absolute top-0 left-0 w-0 h-1 group-hover:w-full transition-all duration-700"
						  style={{ backgroundColor: theme.accent }}
						/>

						{/* Decorative Circle */}
						<div
						  className="absolute -top-14 -right-14 w-36 h-36 rounded-full opacity-0 group-hover:opacity-100 group-hover:scale-150 transition-all duration-700"
						  style={{ backgroundColor: `${theme.accent}10` }}
						/>

						{/* Icon */}
						<motion.div
						  whileHover={{ rotate: 8, scale: 1.12 }}
						  className={`relative z-10 w-20 h-20 ${theme.bg} rounded-2xl flex items-center justify-center mb-7 shadow-sm`}
						>
						  <Icon className={`w-10 h-10 ${theme.icon}`} />
						</motion.div>

						{/* Number */}
						<span className="relative z-10 text-xs font-extrabold tracking-[0.2em] text-gray-300 mb-3">
						  0{index + 1} / UNIVERSITY
						</span>

						{/* Title */}
						<h3 className="relative z-10 text-xl font-extrabold text-[#063B59] mb-4 leading-snug group-hover:text-[#087BA5] transition-colors">
						  {item.title}
						</h3>

						{/* Description */}
						<p className="relative z-10 text-gray-500 text-sm leading-7 mb-7 flex-grow">
						  {item.desc}
						</p>

						{/* Link */}
						<a
						  href={item.link}
						  className="relative z-10 inline-flex items-center justify-between border-t border-gray-100 pt-5 font-bold text-sm text-[#087BA5] group/link"
						>
						  <span className="group-hover/link:underline">
							Explore More
						  </span>

						  <span className="w-10 h-10 rounded-full bg-[#E5F7FD] flex items-center justify-center group-hover:bg-[#087BA5] group-hover:text-white group-hover:translate-x-1 transition-all">
							<ArrowRight size={18} />
						  </span>
						</a>

					  </motion.div>
					);
				  })}

				</div>

				{/* Bottom Message */}
				<motion.div
				  initial={{ opacity: 0, y: 25 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  className="mt-14 text-center"
				>
				  <p className="text-gray-500 text-sm md:text-base">
					Learn, explore and discover endless opportunities at
					<strong className="text-[#087BA5]"> University of Creative Technology Chittagong.</strong>
				  </p>
				</motion.div>

			  </div>
			</section>
			
			<section className="relative overflow-hidden bg-gradient-to-br from-[#F0FCFF] via-white to-[#E8F7FC] py-20 md:py-24">

			  {/* Background Decorations */}
			  <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-cyan-200/25 blur-3xl pointer-events-none" />
			  <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-blue-200/25 blur-3xl pointer-events-none" />

			  <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">

				{/* Section Heading */}
				<motion.div
				  initial={{ opacity: 0, y: 30 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  transition={{ duration: 0.7 }}
				  className="text-center mb-14"
				>
				  <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border border-cyan-100 text-[#087BA5] text-sm font-bold shadow-sm mb-5">
					<Sparkles size={16} />
					UNIVERSITY UPDATES & LEADERSHIP
				  </span>

				  <h2 className="text-3xl md:text-5xl font-extrabold text-[#063B59] mb-4">
					News, Notices &
					<span className="text-[#159BCB]"> Leadership</span>
				  </h2>

				  <p className="max-w-2xl mx-auto text-gray-500 text-base md:text-lg leading-relaxed">
					Stay informed about the latest university announcements and
					discover the vision that inspires our academic community.
				  </p>

				  <div className="flex justify-center items-center gap-2 mt-6">
					<span className="w-14 h-1 bg-[#087BA5] rounded-full" />
					<span className="w-3 h-3 bg-yellow-400 rounded-full" />
					<span className="w-14 h-1 bg-[#087BA5] rounded-full" />
				  </div>
				</motion.div>


				{/* Main Grid */}
				<div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">

				  {/* ===================================
					  LEFT: NOTICE BOARD
				  =================================== */}
				  <motion.div
					initial={{ opacity: 0, x: -50 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.1 }}
					transition={{ duration: 0.8 }}
					className="lg:col-span-7"
				  >

					<div className="h-full bg-white rounded-3xl shadow-[0_10px_45px_rgba(0,60,90,0.08)] border border-gray-100 overflow-hidden">

					  {/* Notice Header */}
					  <div className="relative overflow-hidden bg-gradient-to-r from-[#063B59] to-[#087BA5] px-6 md:px-8 py-7">

						<div className="absolute -right-10 -top-16 w-48 h-48 bg-white/10 rounded-full" />
						<div className="absolute right-20 -bottom-20 w-40 h-40 bg-cyan-300/10 rounded-full" />

						<div className="relative z-10 flex items-center justify-between gap-4">

						  <div className="flex items-center gap-4">
							<div className="w-14 h-14 bg-white/15 backdrop-blur-md rounded-2xl flex items-center justify-center text-yellow-300">
							  <Bell size={28} />
							</div>

							<div>
							  <span className="text-cyan-100 text-xs font-bold uppercase tracking-widest">
								Stay Updated
							  </span>
							  <h3 className="text-2xl md:text-3xl font-extrabold text-white">
								Notice Board
							  </h3>
							</div>
						  </div>

						  <div className="hidden sm:flex items-center gap-2 px-4 py-2 bg-white/15 rounded-full text-white text-xs font-bold">
							<span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
							Latest Updates
						  </div>

						</div>

						<p className="relative z-10 text-white/75 text-sm mt-4">
						  Important announcements, academic updates and university news.
						</p>

					  </div>


					  {/* Notice List */}
					  <div className="p-5 md:p-7">

						<div className="flex items-center justify-between mb-5">
						  <h4 className="font-bold text-[#063B59] flex items-center gap-2">
							<Newspaper size={18} className="text-[#159BCB]" />
							Recent Announcements
						  </h4>

						  <span className="text-xs font-semibold text-gray-400">
							{notices.slice(0, 10).length} Notices
						  </span>
						</div>

						<div className="space-y-3">

						  {notices.slice(0, 10).map((notice, idx) => (

							<motion.a
							  key={notice.id}
							  href={`/notice/${notice.id}`}
							  initial={{ opacity: 0, x: -20 }}
							  whileInView={{ opacity: 1, x: 0 }}
							  viewport={{ once: true }}
							  transition={{
								duration: 0.4,
								delay: idx * 0.06
							  }}
							  whileHover={{ x: 5 }}
							  className="group flex items-center gap-4 p-4 rounded-2xl border border-gray-100 bg-gray-50/70 hover:bg-[#EAF9FE] hover:border-cyan-200 transition-all duration-300"
							>

							  {/* Date */}
							  <div className="shrink-0 w-14 h-14 bg-white rounded-xl border border-gray-100 shadow-sm flex flex-col items-center justify-center group-hover:bg-[#087BA5] group-hover:text-white transition-all">

								<span className="text-lg font-extrabold leading-none text-[#087BA5] group-hover:text-white">
								  {new Date(notice.date).getDate().toString().padStart(2, "0")}
								</span>

								<span className="text-[10px] uppercase font-bold mt-1 text-gray-400 group-hover:text-white/80">
								  {new Date(notice.date).toLocaleDateString("en-GB", {
									month: "short"
								  })}
								</span>

							  </div>


							  {/* Notice Content */}
							  <div className="flex-1 min-w-0">

								<h5 className="text-sm md:text-base font-bold text-gray-700 group-hover:text-[#087BA5] transition-colors leading-relaxed">
								  {notice.head_line}
								</h5>

								<div className="flex items-center gap-2 text-xs text-gray-400 mt-2">
								  <CalendarDays size={13} />
								  {new Date(notice.date).toLocaleDateString("en-GB", {
									day: "2-digit",
									month: "long",
									year: "numeric"
								  })}
								</div>

							  </div>

							  {/* Arrow */}
							  <div className="shrink-0 w-9 h-9 rounded-full bg-white flex items-center justify-center text-[#087BA5] shadow-sm group-hover:bg-[#087BA5] group-hover:text-white transition-all">
								<ChevronRight size={19} />
							  </div>

							</motion.a>

						  ))}

						  {notices.length === 0 && (
							<div className="text-center py-12 text-gray-400">
							  <Newspaper size={36} className="mx-auto mb-3 opacity-40" />
							  <p>No recent notices available.</p>
							</div>
						  )}

						</div>


						{/* View All */}
						<div className="mt-7 pt-5 border-t border-gray-100 flex justify-center">

						  <motion.a
							href="/all-notice"
							whileHover={{ scale: 1.04 }}
							whileTap={{ scale: 0.96 }}
							className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-gradient-to-r from-[#087BA5] to-[#159BCB] text-white font-bold shadow-lg shadow-cyan-700/20 hover:shadow-xl transition-all"
						  >
							View All Notices
							<ArrowRight size={18} />
						  </motion.a>

						</div>

					  </div>
					</div>

				  </motion.div>


				  {/* ===================================
					  RIGHT: FOUNDER MESSAGE
				  =================================== */}
				  <motion.div
					initial={{ opacity: 0, x: 50 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.1 }}
					transition={{ duration: 0.8 }}
					className="lg:col-span-5"
				  >

					<div className="relative h-full overflow-hidden rounded-3xl bg-gradient-to-br from-[#063B59] via-[#075B7D] to-[#087BA5] shadow-[0_15px_50px_rgba(0,60,90,0.18)]">

					  {/* Background Decoration */}
					  <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full border-[35px] border-white/5" />
					  <div className="absolute -bottom-24 -left-16 w-64 h-64 rounded-full bg-cyan-300/10 blur-2xl" />

					  <div className="relative z-10 p-7 md:p-9">

						{/* Heading */}
						<div className="flex items-center gap-3 mb-7">
						  <div className="w-11 h-11 bg-yellow-400 rounded-xl flex items-center justify-center text-[#063B59]">
							<GraduationCap size={24} />
						  </div>

						  <div>
							<span className="text-cyan-200 text-xs font-bold tracking-widest uppercase">
							  Leadership & Vision
							</span>
							<h3 className="text-white text-xl md:text-2xl font-extrabold">
							  Founder's Message
							</h3>
						  </div>
						</div>


						{/* Founder Profile */}
						<div className="flex flex-col items-center text-center mb-7">

						  <motion.div
							animate={{ y: [0, -6, 0] }}
							transition={{
							  duration: 4,
							  repeat: Infinity,
							  ease: "easeInOut"
							}}
							className="relative mb-5"
						  >

							<div className="absolute -inset-2 rounded-full border-2 border-dashed border-yellow-300/70 animate-spin-slow" />

							<img
							  src="/img/Mohammad-Osman.jpg"
							  alt="Founder of University of Creative Technology Chittagong"
							  className="relative w-36 h-36 md:w-40 md:h-40 object-cover rounded-full border-[5px] border-white/90 shadow-2xl"
							/>

							<div className="absolute bottom-2 right-1 w-9 h-9 rounded-full bg-yellow-400 border-4 border-[#075B7D] flex items-center justify-center text-[#063B59]">
							  <Award size={17} />
							</div>

						  </motion.div>

						  <h4 className="text-white text-xl font-extrabold">
							Founder
						  </h4>

						  <p className="text-cyan-200 text-sm font-medium mt-1">
							University of Creative Technology Chittagong
						  </p>

						</div>


						{/* Quote */}
						<div className="relative bg-white/10 backdrop-blur-md border border-white/15 rounded-2xl p-5 md:p-6">

						  <Quote className="text-yellow-300 w-9 h-9 mb-3 opacity-90" />

						  <p className="text-white/90 text-sm md:text-[15px] leading-7">

							<strong className="text-yellow-300">
							  Welcome to the vibrant community of the University of Creative Technology Chittagong (UCTC)!
							</strong>

							<br /><br />

							As the founder, my vision for UCTC is rooted in providing an educational experience that is not only academically enriching but also practical and innovative. At UCTC, our distinguished faculty members, equipped with international degrees and a wealth of experience, are dedicated to cultivating a learning environment that fosters creativity and critical thinking. We believe in shaping graduates who are not just academically proficient but also well-prepared to face the challenges of the evolving global landscape.

							<br /><br />

							I extend my heartfelt gratitude to the UCTC Trust and all our well-wishers whose unwavering support has been instrumental in the establishment of UCTC. Together, we are on a journey to build a university that stands as a beacon of global excellence.

						  </p>

						  <div className="w-16 h-1 bg-yellow-400 rounded-full mt-5" />

						</div>


						{/* Read More */}
						<div className="mt-7 text-center">

						  <motion.a
							href="/founder-message"
							whileHover={{ scale: 1.05, x: 4 }}
							whileTap={{ scale: 0.96 }}
							className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-yellow-400 text-[#063B59] font-extrabold shadow-xl hover:bg-yellow-300 transition-all"
						  >
							Read Full Message
							<ArrowRight size={18} />
						  </motion.a>

						</div>

					  </div>
					</div>

				  </motion.div>

				</div>
			  </div>
			</section>

			
			<section className="bg-gray-50 py-16 px-6 md:px-12">
			  <div className="max-w-6xl mx-auto text-center mb-12">
				<motion.h2
				  initial={{ opacity: 0, y: -30 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  transition={{ duration: 0.8 }}
				  viewport={{ once: true }}
				  className="text-3xl md:text-4xl font-bold text-amber-900"
				>
				  🌟 Campus Activities & Events
				</motion.h2>
				<motion.p
				  initial={{ opacity: 0 }}
				  whileInView={{ opacity: 1 }}
				  transition={{ delay: 0.4, duration: 0.8 }}
				  viewport={{ once: true }}
				  className="text-gray-600 mt-3 max-w-2xl mx-auto"
				>
				  Explore the latest events, cultural programs, and activities happening at
				  our campus. Stay engaged and celebrate every moment of learning and fun!
				</motion.p>
			  </div>

			  {/* Swiper Carousel */}
			  {events.length > 0 ? (
				<Swiper
				  modules={[Autoplay, Pagination, Navigation]}
				  spaceBetween={24}
				  slidesPerView={1}
				  autoplay={{ delay: 3500, disableOnInteraction: false }}
				  pagination={{ clickable: true }}
				  navigation={true}
				  breakpoints={{
					640: { slidesPerView: 1 },
					768: { slidesPerView: 2 },
					1024: { slidesPerView: 4 }, // first show 4 events on desktop
				  }}
				  className="max-w-6xl mx-auto"
				>
				  {events.slice(0, 15).map((event) => (
					<SwiperSlide key={event.id}>
					  <motion.div
						initial={{ opacity: 0, y: 40 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6 }}
						viewport={{ once: true }}
						className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition transform hover:-translate-y-2"
					  >
						<img
						  src={`${import.meta.env.VITE_API_SOURCE_URL}${event.images}` || "/default-event.jpg"}
						  alt={event.name}
						  className="w-full h-48 object-cover"
						/>
						<div className="p-5 text-left">
						  <h3 className="text-lg font-semibold text-[#016C94] mb-2">
							{event.name?.slice(0, 50) + '...' }							
						  </h3>
						  <p className="text-gray-600 text-sm mb-3">
							{event.description?.slice(0, 80)}...
						  </p>
						  <div className="flex justify-between items-center text-sm text-gray-500">
							<span>
							  📅{" "}
							  {new Date(event.start_date).toLocaleDateString("en-GB", {
								day: "2-digit",
								month: "short",
								year: "numeric",
							  })}
							</span>
							<a
							  href={`/events/${event.id}`}
							  className="text-green-700 font-medium hover:underline"
							>
							  Read More →
							</a>
						  </div>
						</div>
					  </motion.div>
					</SwiperSlide>
				  ))}
				</Swiper>
			  ) : (
				<p className="text-center text-gray-500">No events available.</p>
			  )}

			  {/* All Events Button */}
			  <div className="text-center mt-12">
				<motion.a
				  href="/all-events"
				  whileHover={{ scale: 1.05 }}
				  whileTap={{ scale: 0.95 }}
				  className="inline-block bg-[#1f6da8] text-white px-8 py-3 rounded-full shadow hover:bg-amber-800 transition"
				>
				  View All Events
				</motion.a>
			  </div>
			</section>
			
			
			<section className="bg-[#F0FCFF] py-16 px-6 md:px-12">
			  {/* Heading */}
			  <div className="max-w-7xl mx-auto text-center mb-12">
				<motion.h2
				  initial={{ opacity: 0, y: -30 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  transition={{ duration: 0.8 }}
				  viewport={{ once: true }}
				  className="text-3xl md:text-4xl font-bold text-[#016C94]"
				>
				  📰 Recent News
				</motion.h2>
				<motion.p
				  initial={{ opacity: 0 }}
				  whileInView={{ opacity: 1 }}
				  transition={{ delay: 0.4, duration: 0.8 }}
				  viewport={{ once: true }}
				  className="text-gray-600 mt-3 max-w-2xl mx-auto"
				>
				  Stay updated with the latest announcements, updates, and happenings from
				  our institution.
				</motion.p>
			  </div>

			  {/* Swiper Carousel */}
			  {news.length > 0 ? (
				<Swiper
				  modules={[Autoplay, Pagination, Navigation]}
				  spaceBetween={24}
				  slidesPerView={1}
				  autoplay={{ delay: 4000, disableOnInteraction: false }}
				  pagination={{ clickable: true }}
				  navigation={true}
				  breakpoints={{
					640: { slidesPerView: 1 },
					768: { slidesPerView: 2 },
					1024: { slidesPerView: 4 }, // Show 4 news on desktop
				  }}
				  className="max-w-6xl mx-auto"
				>
				  {news.slice(0,15).map((item) => (
					<SwiperSlide key={item.id}>
					  <motion.div
						initial={{ opacity: 0, y: 40 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6 }}
						viewport={{ once: true }}
						className="bg-gray-50 rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition transform hover:-translate-y-2"
					  >
						<img
						  src={`${import.meta.env.VITE_API_SOURCE_URL}${item.images_path}` || "/default-news.jpg"}
						  alt={item.head_line}
						  className="w-full h-40 object-cover"
						/>
						<div className="p-5 text-left">
						  <h3 className="text-lg font-semibold text-[#016C94] mb-2 line-clamp-2">
							{item.head_line > 50 ? item.head_line.substring(0, 50) + '...' : item.head_line}
							
						  </h3>
						  <p className="text-gray-600 text-sm mb-3 line-clamp-3">
							{item.description?.slice(0, 90)}...
						  </p>
						  <div className="flex justify-between items-center text-sm text-gray-500">
							<span>
							  📅{" "}
							  {new Date(item.date).toLocaleDateString("en-GB", {
								day: "2-digit",
								month: "short",
								year: "numeric",
							  })}
							</span>
							<a
							  href={`/news/${item.id}`}
							  className="text-green-700 font-medium hover:underline"
							>
							  Read More →
							</a>
						  </div>
						</div>
					  </motion.div>
					</SwiperSlide>
				  ))}
				</Swiper>
			  ) : (
				<p className="text-center text-gray-500">No news available.</p>
			  )}

			  {/* All News Button */}
			  <div className="text-center mt-12">
				<motion.a
				  href="/all-news"
				  whileHover={{ scale: 1.05 }}
				  whileTap={{ scale: 0.95 }}
				  className="inline-block bg-[#1f6da8] text-white px-8 py-3 rounded-full shadow hover:bg-[#014864] transition animate-pulse"
				>
				  View All News
				</motion.a>
			  </div>
			</section>
			
			<section className="w-full bg-[#B7EAFC] py-16 px-6 md:px-20">
			  <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-start">
				{/* Left Side - Main Video */}
				<motion.div 
					initial={{ opacity: 0, x: 60 }}
					whileInView={{ opacity: 1, x: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
					className="w-full">
				  {selectedVideo ? (
					<>
					  <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
						<iframe
						  className="w-full h-full"
						  src={`https://www.youtube.com/embed/${selectedVideo.video_id}?rel=0&autoplay=${
							autoPlay ? 1 : 0
						  }`}
						  title={selectedVideo.title}
						  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						  allowFullScreen
						></iframe>
					  </div>
					  <h3 className="mt-4 text-xl font-semibold text-[#016C94]">
						{selectedVideo.title}
					  </h3>
					</>
				  ) : (
					<p className="text-gray-600">Loading video...</p>
				  )}
				</motion.div>

				{/* Right Side - Recent Videos */}
				<motion.div
					initial={{ opacity: 0, x: 60 }}
					whileInView={{ opacity: 1, x: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
					className="space-y-4">
				  <h2 className="text-2xl font-bold text-[#016C94] mb-4">Recent Videos</h2>
				  {videos.slice(0,4).map((video) => (
					<div
					  key={video.id}
					  onClick={() => handleVideoClick(video)}
					  className={`flex items-center gap-4 p-3 rounded-lg cursor-pointer transition ${
						selectedVideo?.id === video.id
						  ? "bg-green-100"
						  : "hover:bg-green-50"
					  }`}
					>
					  <img
						src={
						  video.thumbnail ||
						  `https://img.youtube.com/vi/${video.video_id}/hqdefault.jpg`
						}
						alt={video.title}
						className="w-28 h-16 rounded-lg object-cover"
					  />
					  <p className="text-[#016C94] font-medium">{video.title}</p>
					</div>
				  ))}
				</motion.div>
			  </div>
			</section>
			
			
		</>
		
	);
}
export default HomePage;
